import {SearchErrorsFactory} from '../../search/Errors/factory.js'
import {SearchRequestValueObject} from '../../search/ValueObjects/SearchRequestValueObject.js'
import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetModelDetailRelevantAdsRequestValueObject extends SearchRequestValueObject {
  static validate({categoryId, makeId, model, offerTypeId, sortBy, sortOrder, page}) {
    SearchRequestValueObject.validate({
      invalidRequestSearchErrorFactory: SearchErrorsFactory.invalidRequestSearchError,
      categoryId,
      offerTypeId,
      page,
      sortBy,
      sortOrder
    })
    if (!makeId || !model?.id) {
      throw InvalidParamsSharedError.create(
        `[GetModelDetailRelevantAdsRequestValueObject.validate] param makeId and model are required`
      )
    }
  }

  static create({
    bodyTypeIds,
    category1Id,
    category2Id,
    category3Id,
    categoryId,
    colorIds,
    commitmentMonths,
    contractId,
    doors,
    drivenWheelsIds,
    environmentalLabels,
    equipments,
    fee,
    filteredOfferTypeId,
    financedPrice,
    fuelTypeIds,
    hasInstalment,
    hasPhoto,
    hasStock,
    hasWarranty,
    hp,
    instalment,
    isCertified,
    kms,
    litres,
    location,
    luggageCapacity,
    make,
    makeId,
    model,
    modelVersionId,
    monthlySubscriptionFee,
    offerTypeId,
    onlyPeninsula,
    page,
    price,
    province,
    provinceIds,
    searchText,
    seats,
    sellerTypeId,
    size,
    sortBy,
    sortOrder,
    subscriptionVehicleState,
    transmissionTypeId,
    vehicles,
    version,
    year
  }) {
    GetModelDetailRelevantAdsRequestValueObject.validate({
      categoryId,
      makeId,
      model,
      offerTypeId,
      page,
      sortBy,
      sortOrder
    })
    return new GetModelDetailRelevantAdsRequestValueObject({
      bodyTypeIds,
      category1Id,
      category2Id,
      category3Id,
      categoryId,
      colorIds,
      commitmentMonths,
      contractId,
      doors,
      drivenWheelsIds,
      environmentalLabels,
      equipments,
      fee,
      filteredOfferTypeId,
      financedPrice,
      fuelTypeIds,
      hasInstalment,
      hasPhoto,
      hasStock,
      hasWarranty,
      hp,
      instalment,
      isCertified,
      kms,
      litres,
      location,
      luggageCapacity,
      make,
      makeId,
      model,
      modelVersionId,
      monthlySubscriptionFee,
      offerTypeId,
      onlyPeninsula,
      page,
      price,
      province,
      provinceIds,
      searchText,
      seats,
      sellerTypeId,
      size,
      sortBy,
      sortOrder,
      subscriptionVehicleState,
      transmissionTypeId,
      vehicles,
      version,
      year
    })
  }

  constructor({
    bodyTypeIds,
    category1Id,
    category2Id,
    category3Id,
    categoryId,
    colorIds,
    commitmentMonths,
    contractId,
    doors,
    drivenWheelsIds,
    environmentalLabels,
    equipments,
    fee,
    filteredOfferTypeId,
    financedPrice,
    fuelTypeIds,
    hasInstalment,
    hasPhoto,
    hasStock,
    hasWarranty,
    hp,
    instalment,
    isCertified,
    kms,
    litres,
    location,
    luggageCapacity,
    make,
    makeId,
    model,
    modelVersionId,
    monthlySubscriptionFee,
    offerTypeId,
    onlyPeninsula,
    page,
    price,
    province,
    provinceIds,
    searchText,
    seats,
    sellerTypeId,
    size,
    sortBy,
    sortOrder,
    subscriptionVehicleState,
    transmissionTypeId,
    vehicles,
    version,
    year
  }) {
    super({
      bodyTypeIds,
      category1Id,
      category2Id,
      category3Id,
      categoryId,
      colorIds,
      commitmentMonths,
      contractId,
      doors,
      drivenWheelsIds,
      environmentalLabels,
      equipments,
      fee,
      filteredOfferTypeId,
      financedPrice,
      fuelTypeIds,
      hasInstalment,
      hasPhoto,
      hasStock,
      hasWarranty,
      hp,
      instalment,
      isCertified,
      kms,
      litres,
      location,
      luggageCapacity,
      make,
      makeId,
      model,
      modelVersionId,
      monthlySubscriptionFee,
      offerTypeId,
      onlyPeninsula,
      page,
      price,
      province,
      provinceIds,
      searchText,
      seats,
      sellerTypeId,
      size,
      sortBy,
      sortOrder,
      subscriptionVehicleState,
      transmissionTypeId,
      vehicles,
      version,
      year
    })
  }
}
